import { axiosServices } from "./axiosServices";

export const packageServices = { getPackageDetail, getPackageListing, getPackageBoq, viewUrlData, packageCreation, editPackage, getFilterDetail, getDocuments, deletePackage, poQtyModification, addPRNumber ,getPackageFieldList, assignBuyer};

function getPackageListing(param) {
  return axiosServices.getAxios(`/v1/internal/packages/${param}`).then((res) => {
    return res;
  });
}

function getPackageDetail(packageId) {
  return axiosServices
    .getAxios(`/v1/internal/packages/${packageId}`)
    .then((res) => {
      return res;
    });
}

function getPackageBoq(packageId, param) {
  return axiosServices.getAxios(`/v1/internal/packages/${packageId}/boqs/${param}`).then((res) => {
    return res;
  });
}

function viewUrlData(id) {
  return axiosServices
    .getAxios(`/v1/common/sub/upload?key=${id}`)
    .then((res) => {
      return res;
    });
}


function packageCreation(bodyData) {
  return axiosServices
    .postAxios("/v1/internal/packages", bodyData)
    .then((res) => {
      return res;
    });
}

function editPackage(id, bodyData) {
  return axiosServices
    .putAxios(`/v1/internal/packages/${id}`, bodyData)
    .then((res) => {
      return res;
    });
}

function getFilterDetail(uniqueName) {
  return axiosServices
    .getAxios(`/v1/common/filters?uniqueName=${uniqueName}`)
    .then((res) => {
      return res;
    });
}

function getDocuments(param) {
  return axiosServices
    .getAxios(`/v1/internal/packages/documents`)
    .then((res) => {
      return res;
    });
}

function deletePackage(packageId, bodyData) {
  return axiosServices
    .deleteAxios(`/v1/internal/packages/${packageId}`, bodyData)
    .then((res) => {
      return res;
    });
}

function poQtyModification(bodyData) {
  return axiosServices
    .postAxios("/v1/common/po-modification-requests/quantity", bodyData)
    .then((res) => {
      return res;
    });
}

function addPRNumber(id, bodyData, type) {
  return axiosServices
    .postAxios(`/v1/internal/${type}/${id}/add-pr-number`, bodyData)
    .then((res) => {
      return res;
    });
}

function getPackageFieldList(moduleName , page) {
    return axiosServices.getAxios(`/v1/common/field-configs?moduleName=${moduleName}&page=${page}`).then((res) => {
      return res;
  })
}

function assignBuyer(packageId, buyerId) {
  return axiosServices
    .postAxios(`/v1/internal/packages/${packageId}/assign-buyer`, buyerId)
    .then((res) => {
      return res;
    });
}
